import styled from 'styled-components';
import { colors, font, breakpoints } from '@chegg-ui/theme';
import { Font } from '../common/styled/common';
import { PAY_W_UPI_ICON } from '../../constants/AppConstants';
var dark = colors.dark;
var family = font.family,
  weight = font.weight,
  size = font.size;
export var UpiContainer = styled.div.withConfig({
  componentId: "sc-1vc3zbi-0"
})(["display:block;"]);
export var PaymentTopHeader = styled.h2.withConfig({
  componentId: "sc-1vc3zbi-1"
})(["color:", ";font-family:", ";font-weight:", ";margin:0 0 10px 0;font-size:", ";"], dark, family.aspira, weight.bold, size.px18);
export var UpiFormContainer = styled.form.withConfig({
  componentId: "sc-1vc3zbi-2"
})(["", " border:2px solid ", ";min-width:230px;line-height:initial;border-radius:8px;fieldset{border-width:0;padding:0 10px;}"], Font, colors.greyLight);
UpiFormContainer.displayName = 'UpiFormContainer';
export var UpiFormHeader = styled.div.withConfig({
  componentId: "sc-1vc3zbi-3"
})(["background:", ";padding:16px;border-radius:8px 8px 0 0;", " font-weight:", ";font-size:", ";line-height:27px;margin:0px;background-image:url(", ");background-position:right 16px center;background-repeat:no-repeat;"], colors.greyXlight, Font, weight.bold, size.px18, PAY_W_UPI_ICON);
export var UpiFormHeaderVariant = styled.div.withConfig({
  componentId: "sc-1vc3zbi-4"
})(["background:", ";padding:16px;border-radius:8px 8px 0 0;", " font-weight:", ";font-size:", ";line-height:27px;margin:0px;@media (max-width:", "){font-size:", ";}"], colors.greyXlight, Font, weight.bold, size.px18, breakpoints.sm.max, size.px16);
export var UpiLogo = styled.div.withConfig({
  componentId: "sc-1vc3zbi-5"
})(["display:inline-block;background-image:url(", ");background-repeat:no-repeat;background-color:#fff;background-size:57px 27px;border:1px solid ", ";height:27px;width:57px;@media (max-width:", "){background-size:40px 21px;width:40px;height:21px;}"], PAY_W_UPI_ICON, colors.greyMedlight, breakpoints.sm.max);
export var CardLogoContainer = styled.div.withConfig({
  componentId: "sc-1vc3zbi-6"
})(["display:inline-block;div{margin-left:4px;}"]);
export var UpiFormInputs = styled.div.withConfig({
  componentId: "sc-1vc3zbi-7"
})(["transition:0.2s all;position:relative;padding-top:10px;padding-bottom:15px;overflow:inherit;max-height:600px;visibility:visible;"]);
export var CountryLabel = styled.label.withConfig({
  componentId: "sc-1vc3zbi-8"
})(["display:block;", " font-weight:", ";font-size:", ";line-height:130%;color:", ";margin-bottom:8px;"], Font, font.weight.bold, font.size.px12, colors.grey600);
export var DisabledCountryInput = styled.div.withConfig({
  componentId: "sc-1vc3zbi-9"
})(["display:flex;align-content:flex-start;align-items:center;border-radius:4px;", " font-size:", ";background-color:", ";height:48px;line-height:48px;pointer-events:none;cursor:not-allowed;.text{flex-grow:1;}svg{margin:auto 20px;}"], Font, font.size.px16, colors.grey200);
export var UpiProcessingWrapper = styled.section.withConfig({
  componentId: "sc-1vc3zbi-10"
})(["display:flex;position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(55,55,55,0.34);z-index:101;justify-content:center;align-items:center;align-content:center;text-align:center;"]);
export var UpiProcessingModal = styled.div.withConfig({
  componentId: "sc-1vc3zbi-11"
})(["position:relative;display:flex;width:340px;min-height:170px;align-items:center;justify-content:center;background-color:#fff;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UpiOption/styled.js
// module id = 895
// module chunks = 11